import { Card } from '@mui/material';
import { styled } from '@mui/material/styles';

// Common bordered, shadowless card used across the profile sections.
// Default padding is responsive (1.25rem on small screens, 1.5rem from md up);
// override padding / margin / width via the `sx` prop on a per-use basis.
const SectionCard = styled(Card)(({ theme }) => ({
  boxShadow: 'none',
  borderRadius: '16px',
  border: `1px solid ${theme.palette.customColors.gray300}`,
  overflow: 'hidden',
  padding: '1.5rem',
  [theme.breakpoints.down('md')]: {
    padding: '1.25rem',
  },
}));

export default SectionCard;
